import assignedTo from './assigned-to';
import createdDate from './created-date';
import processedBy from './processed-by';
import processedDate from './processed-date';
import shipDate from './ship-date';
import shipFrom from './ship-from';
import { OPEN, PROCESSED, ARCHIVED } from '../../constants';
import { buildFilterObject } from '../../../../../components/filter-bar';
import { dateFilterOperators } from '../../../../../containers/base-filter-bar-container/reference-data-criteria-arguments';
import { orderDateOperators } from '../../../../../containers/base-filter-bar-container/criteria-operators';

export const openOptions = [assignedTo, createdDate];

export const processedOptions = [shipFrom, processedBy, processedDate, shipDate];

export const archivedOptions = [shipFrom, processedBy, processedDate, shipDate];

const DEFAULT_SHIPDATE_DAYS = '14';
const withinXDaysOperator = orderDateOperators.find((x) => x.id === dateFilterOperators.dateWithinThePastXDays);
export const getDefaultFiltersForTab = (selectedTab, meta) => {
  const defaultFilters = [];

  const shipDatefilter = buildFilterObject(shipDate, withinXDaysOperator, { value: DEFAULT_SHIPDATE_DAYS }, undefined);

  const createdDateFilter = buildFilterObject(createdDate, withinXDaysOperator, { value: DEFAULT_SHIPDATE_DAYS }, undefined);

  if (selectedTab === OPEN) {
    defaultFilters.push(createdDateFilter);
  }
  if (selectedTab === PROCESSED) {
    if (meta.currentUserId) {
      const userFilter = buildFilterObject(processedBy, undefined, { value: meta.currentUserId }, undefined);
      defaultFilters.push(userFilter);
    }
    defaultFilters.push(shipDatefilter);
  }
  if (selectedTab === ARCHIVED) {
    defaultFilters.push(shipDatefilter);
  }

  return defaultFilters;
};

export default [assignedTo, createdDate, processedBy, processedDate, shipDate, shipFrom];
